import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------ COMPONENTES DE BASE--------------------------
import Loader from "../../../Base/Components/Loader/Loader";
import Card from "../../../Base/Components/Card/Card";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { useForm } from "../../../Base/Hooks/useForm";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../Base/Services/ToastService";
import { getPersonalAct, getPersonall } from "../../../API/RRHH/Personal/PersonalRequest";
import { getTasaCambio } from "../../../API/CalendarioOperativo/CalendarioOperativoRequest";
import { getAreasAct } from "../../../Base/API/Global/Areas/AreasRequests";

// ------------------- CONSULTAS A LA API---------------------------



const ComprobanteCRUD = ({
  showDialog,
  setShowDialog,
  selectedEnc,
  setSelectedEnc,
  getInfo,
  habilitar,
  setHabilitar,
  IdCurrency
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [detalles, setDetalles] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cuentas, setCuentas] = useState([]);
  const [personal, setPersonal] = useState([]);
  const [areas, setAreas] = useState([]);
  const [usuariosAutorizan, setUsuariosAutorizan] = useState([]);
  const [selectedFacturas, setSelectedFacturas] = useState([]);
  const [cuentasDetalles, setCuentasDetalles] = useState([]);
  const [showDialogReporte, setShowDialogReporte] = useState(false);
  const [Languaje, setLanguaje] = useState('es');
    

  const initialValues = {
    IdComprobante: -1,
    IdStatus: 128,
    StatusName: 'Creado',
  };

  const { values, setValues, handleInputChange, handleChange, resetForm } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    setSelected([])

    const personalTempo = await getPersonall()
    setPersonal(personalTempo)

    const areasTempo = await getAreasAct()
    setAreas(areasTempo)
    
    if(selectedEnc[0]?.IdComprobante){
        let IdComprobante = selectedEnc[0]?.IdComprobante
        //ACA TRAE LA INFO, VAYA A TRAERLA HAGA LA RUTA NO UN FILTRO DE TODA LA INFO jaja
    }else{
        const tasaTempo = await getTasaCambio()
        setValues({
            ...values,
            TasaCambio: tasaTempo[0]?.TasaCambio
        })
        
    }


    setLoading(false);
  };

  const getNuevaNota = async () => {};

  const tiposPersonal = [
    {
      IdTipoPersonal: 1,
      TipoPersonal: "Personal PPF",
    },
    {
      IdTipoPersonal: 2,
      TipoPersonal: "Otros",
    },
  ];

  const tipoNotaCredito = [
    {
      TipoNotaCredito: "Devolución",
      IdTipoNotaCredito: 1,
    },
    {
      TipoNotaCredito: "Cambio de Precio",
      IdTipoNotaCredito: 2,
    },
    {
      TipoNotaCredito: "Diferencial Cambiario",
      IdTipoNotaCredito: 3,
    },
  ];

  const verificarCampos = () => {
    let err = false;

    if (!values?.NumeroNota) {
      err = true;
      toastShow(toast, "error", "Error", "No.Nota es requerido.");
      return;
    }
    if (!values?.CustomerName && !values?.IdVendor) {
      err = true;
      toastShow(toast, "error", "Error", "Proveedor es requerido.");
      return;
    }
    if (!values?.FechaEmisionStr) {
      err = true;
      toastShow(toast, "error", "Error", "La fecha de emisión es requerida.");
      return;
    }
    if (!values?.Currency && !values?.IdCurrency) {
      err = true;
      toastShow(toast, "error", "Error", "Moneda es requerida.");
      return;
    }
    if (!values?.Monto) {
      err = true;
      toastShow(toast, "error", "Error", "No.Nota es requerido.");
      return;
    }
    if (!values?.Inventario && !values?.IdTipoIngreso) {
      err = true;
      toastShow(toast, "error", "Error", "Inventario es requerido.");
      return;
    }

    if (detalles.length > 0) {
      detalles.forEach((l) => {
        if (!l.IdTipoNotaCredito) {
          toastShow(toast, 'error', 'Error', 'Debe seleccionar el tipo de nota de crédito en todos los detalles')
          err = true
          return
        }
      });

      detalles.forEach((l) => {
        if (!l.IdCuenta) {
          toastShow(toast, 'error', 'Error', 'Debe seleccionar una cuenta en todos los detalles')
          err = true
          return
        }
      })
    }

    return !err;
  };
  
  const guardarNota = async () => {
    // if(verificarCampos()){

    //   let tempoMontoD;
    //   let tempoMontoL;
    //   if (values.IdMoneda === 1) {
    //     tempoMontoL = values.Monto * values.TasaCambio;
    //     tempoMontoD = values.Monto;
    //   } else {
    //     tempoMontoL = values.Monto;
    //     tempoMontoD = values.Monto / values.TasaCambio;
    //   }
    //   setValues({ ...values, MontoL: tempoMontoL, MontoD: tempoMontoD });

    //   let encabezado = {
    //     ...values,
    //     FechaEmision: getDateTimeStringSQL(new Date(values.FechaEmisionStr)),
    //     IdUserEdit: userAuth?.IdUser,
    //     IdUserCreate: userAuth?.IdUser,
    //     MontoD: tempoMontoD,
    //     MontoL: tempoMontoL,
    //     IdCuentaCredito: values?.IdCuentaCredito,
    //     IdCuentaDebito: values?.IdCuentaDebito?.IdAccount || values?.IdCuentaDebito,
    //     IdVendor: values?.CustomerName?.IdVendor || values?.IdVendor,
    //     IdCurrency: values?.Currency?.IdCurrency || values?.IdCurrency,
    //     IdTipoIngreso: values?.Inventario?.IdTipoIngreso || values?.IdTipoIngreso,
    //     IdStatus: values?.StatusName?.IdStatus || values?.IdStatus,
    //     IdRango: values?.IdRango,
    //     IdExoneracion: values?.IdExoneracion,
    //   }
    //   let message = <div>¿Está seguro que desea guardar la información?</div>
    //   console.log(encabezado);
    //   confirmDialog({
    //     message: message,
    //     header: "Confirmación",
    //     icon: "pi pi-exclamation-triangle",
    //     accept: async () => {
    //       setLoading(true);
    //       if(encabezado.IdComprobante <= 0){
    //         const resp = await GuardarNotaCreditoProveedor(encabezado, detalles);
    //         if(resp[0]?.ESTADO === 1){
    //           toastShow(toast, "success", "Guardada", resp[0]?.MENSAJE);
    //           setTimeout(() => {
    //             setShowDialog(false);
    //           }, 700);
    //           getInfo()
    //           setSelectedEnc([])
    //         }else{
    //           toastShow(toast, "error", "Error", 'Error al guardar la nota de crédito');
    //         }
    //       }else{
    //         const resp = await EditarNotaCreditoProveedor(encabezado, detalles);
    //         if(resp[0]?.ESTADO === 1){
    //           toastShow(toast, "success", "Editada", resp[0]?.MENSAJE);
    //           setTimeout(() => {
    //             setShowDialog(false);
    //           }, 700);
    //           getInfo()
    //           setSelectedEnc([])
    //         }else{
    //           toastShow(toast, "error", "Error", 'Error al editar la nota de crédito');
    //         }
    //       }
    //       setLoading(false);
    //     },
    //     reject: () => {},
    //   });
    // }
  };

  const agregarNuevaFila = (infoIngreso) => {
    // let newRow = [...detalles];
  
    // let FacturaExistente = detalles.some((i) =>
    //   infoIngreso.some((f) => i.IdIngresoDetalle === f.IdIngresoDetalle && i.Factura === f.Factura)
    // );
  
    // if (FacturaExistente) {
    //   toastShow(toast, "error", "Error", "No se permiten valores repetidos");
    // } else {
    //   let dataNueva = [];
  
    //   infoIngreso.forEach((f) => {
    //     let Id = (detalles.length + dataNueva.length + 1) * (-1);
  
    //     const nuevoDetalle = {
    //       IdDetalle: Id,
    //       IdComprobante: values.IdComprobante,
    //       IdStatus: 75,
    //       IdIngresoDetalle: f.IdIngresoDetalle,
    //       IdTipoIngreso: values?.Inventario?.IdTipoIngreso || values?.IdTipoIngreso,
  
    //       PrecioFD: f.PrecioD,
    //       PrecioFL: f.PrecioL,
    //       PrecioD: f.PrecioD,
    //       PrecioL: f.PrecioL,
  
    //       MontoFD: f.MontoD,
    //       MontoFL: f.MontoL,
    //       MontoL: f.MontoL,
    //       MontoD: f.MontoD,
  
    //       Cantidad: f.BalanceDevolucion,
    //       CantidadF: f.BalanceDevolucion,
    //       BalanceDevolucion: f.BalanceDevolucion,
  
    //       TasaCambioF: f.TasaCambio,
    //       TasaCambio: f.TasaCambio,
  
    //       Memo: '',
    //       PurchaseOrder: f.PurchaseOrder,
    //       Factura: f.Factura,
    //       IdUnit: f.IdUnit,
    //       UnitName: f.UnitName,
    //       IdProduct: f.IdProduct,
    //       CodigoProducto: f.CodigoProducto,
    //       NombreProducto: f.NombreProducto,
    //       IdUserEdit: userAuth?.IdUser,
    //       IdUserCreate: userAuth?.IdUser,
    //       NumeroIngreso: f.NumeroIngreso,
    //       IdIngreso: f.IdIngreso,
    //       IdPurchaseOrderDetail: f.IdPurchaseOrderDetail,
    //       IdTipoNotaCredito: null,
    //       TipoNotaCredito: null,
    //     };
  
    //     // 🔹 Backup de los valores originales
    //     nuevoDetalle._originalValues = {
    //       Cantidad: nuevoDetalle.Cantidad,
    //       TasaCambio: nuevoDetalle.TasaCambio,
    //       PrecioL: nuevoDetalle.PrecioL,
    //       PrecioD: nuevoDetalle.PrecioD,
    //       MontoL: nuevoDetalle.MontoL,
    //       MontoD: nuevoDetalle.MontoD,
    //       IdTipoNotaCredito: nuevoDetalle.IdTipoNotaCredito
    //     };
  
    //     dataNueva.push(nuevoDetalle);
    //   });
  
    //   let nuevoArreglo = detalles.concat(dataNueva);
    //   setSelectedFacturas([]);
    //   setDetalles(nuevoArreglo);
    // }
  };

  const EliminarDetalle = async () => {
    // if (selected.some(item => item.IdDetalle > 0)) {
    //   confirmDialog({
    //     message: "¿Está seguro que desea eliminar el detalle?",
    //     header: "Confirmación",
    //     icon: "pi pi-exclamation-triangle",
    //     accept: async () => {
    //       setLoading(true);
    //       const nuevosDetalles = detalles.filter(detalle => !selected.some(item => item.IdDetalle === detalle.IdDetalle));
    //       const Ids = selected.filter(item => item.IdDetalle > 0).map(item => item.IdDetalle).join(',');
    //       const resp = await eliminarDetalles(Ids);
    //       toastShow(toast, "success", "Eliminado", 'Detalles eliminados correctamente');
    //       setTimeout(() => {            
    //         setLoading(false);
    //         setDetalles(nuevosDetalles);
    //         setSelected([]);
    //       }, 600);
    //     },
    //     reject: () => {},
    //   })
    // } else {
    //   const idsAEliminar = selected.map(item => item.IdDetalle);
    //   const nuevosDetalles = detalles.filter(
    //     detalle => !idsAEliminar.includes(detalle.IdDetalle)
    //   );
    //   setDetalles(nuevosDetalles);
    //   setSelected([]);
    // }
  };
  
  const AplicarNotaCredito = () => {
    // let message = (
    //   <div>
    //     <span>¿Está seguro que desea aplicar la nota de crédito?</span>
    //     <br />
    //     <span>Al aplicarse afectara los ingresos seleccionados</span>
    //   </div>
    // );
    // confirmDialog({
    //   message: message,
    //   header: "Confirmación",
    //   icon: "pi pi-exclamation-triangle",
    //   accept: async () => {
    //     const detallesDev = detalles.map((i) => {
    //       return {
    //         IdIngresoDetalle: i.IdIngresoDetalle,
    //         Devolucion: i.Cantidad,
    //         FechaDevolucion: getDateTimeStringSQL(new Date(values.FechaEmisionStr)),
    //         IdUserDevolucion: userAuth.IdUser,
    //         Comentario: i.Memo,
    //         IdTipoNotaCredito: i.IdTipoNotaCredito,
    //         TasaCambio: i.TasaCambio,

    //         PrecioL: i.PrecioL,
    //         PrecioD: i.PrecioD,

    //         SubTotalL: i.PrecioL * i.Cantidad,
    //         SubTotalD: i.PrecioD * i.Cantidad,

    //         ISVL: (i.ISVProductoL / i.Ingreso) * i.Cantidad,
    //         ISVD: (i.ISVProductoD / i.Ingreso) * i.Cantidad,

    //         ISV18L: (i.ISV18ProductoL / i.Ingreso) * i.Cantidad,
    //         ISV18D: (i.ISV18ProductoD / i.Ingreso) * i.Cantidad,

    //         DescuentoL: (i.Descuento / i.Ingreso) * i.Cantidad,
    //         DescuentoD: (i.DescuentoD / i.Ingreso) * i.Cantidad,

    //         MontoL: i.MontoL,
    //         MontoD: i.MontoD,
    //         IdPurchaseOrderDetail: i.IdPurchaseOrderDetail,
    //         IdProducto: i.IdProduct,
    //       };
    //     });

    //     const datosEnviar = {
    //       Detalles: detallesDev,
    //       IdTipoIngreso: values?.IdTipoIngreso,
    //       IdComprobante: values?.IdComprobante,
    //     };

    //     const result = await AplicarNota(datosEnviar);

    //     let respuesta = result[0];
    //     if (respuesta?.ESTADO === 1) {
    //       toastShow(toast, "success", "Aplicada", respuesta?.MENSAJE);
    //       getValoresIniciales();
    //       getInfo();
    //     } else {
    //       toastShow(toast, "error", "Error", respuesta?.MENSAJE);
    //     }
    //   },
    //   reject: () => {},
    // });
  };

  const columns = [
    {
      field: "IdDetalle",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
    },
    {
      header: "Código",
      headerEn: "Code",
      field: "CodigoProducto",
      className: "small",
    },
    {
      header: "Producto",
      headerEn: "Product",
      field: "NombreProducto",
      className: "XXlarge",
    },
    {
      header: "TipoProducto",
      headerEn: "ProductType",
      field: "NombreCategoria",
      className: "medium",
    },
    {
      header: "Categoría",
      headerEn: "Category",
      field: "NombreSubCategoria",
      className: "medium",
    },

    {
      header: "Proveedor",
      headerEn: "CustomerName",
      field: "CustomerName",
      className: "Xlarge",
    },
    {
      header: "CAI",
      headerEn: "CAI",
      field: "CAI",
      className: "Xlarge",
    },
    {
      field: "Factura",
      header: "Factura",
      headerEn: "Invoice",
      className: "medium",
    },
    {
      field: "FechaFactura",
      header: "Fecha Factura",
      headerEn: "Invoice Date",
      Format: 'DateTime',
    },
    {
      field: "Area",
      header: "Area",
      className: "small",
    },
    {
      field: "NombreCuenta",
      header: "Cuenta",
      headerEn: "Account",
      className: "XXlarge",
    },
    {
        field: 'IsDobleCuenta',
        header: 'IsDobleCuenta',
        className: 'Xsmall',
        Format: 'Checkbox',
        filter: true,
        // onChange: (e, rowData) => {

        //     CuentaDoble(rowData.value, rowData.data)
        // },
        // Disabled: ({ data }) => {
        //     if (values.IdStatus !== 1021 && !deshabilitarEdicion)
        //         return true
        //     return false
        // }
    },

    {
      field: "MontoL",
      header: "Monto L",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
      editable: habilitar,
    },
  ];

  const table = {
    Columns: columns,
    Data: detalles,
    selected: selected,
    setSelected: setSelected,
    showModal: (e) => {},
  };

  useEffect(() => {
    getValoresIniciales(selectedEnc);
  }, [selectedEnc]);

  useEffect(() => {
    let IdVendor = values?.CustomerName?.IdVendor || values?.IdVendor;
    if (IdVendor) {
      let IdCountry = values?.CustomerName?.IdCountry || values?.IdCountry;
      let cuenta
      if (IdCountry === 95) {
        cuenta = cuentas?.find((i) => i.IdAccount === 15);
      } else {
        cuenta = cuentas?.find((i) => i.IdAccount === 16);
      }

      setValues({
        ...values,
        IdCuentaDebito: cuenta,
        NombreCuenta: cuenta,
      })
    }
  }, [values?.CustomerName?.IdVendor, values?.IdVendor]);
  
  const cerrarDialog = () => {
    if(habilitar){
      confirmDialog({
        message: "¿Está seguro que desea salir sin guardar?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          setShowDialog(false);
          setSelectedEnc([])
          resetForm()
          setDetalles([])
          setHabilitar(true)
        },
        reject: () => {},
      });
    }else{
      setShowDialog(false);
      setSelectedEnc([])
      setHabilitar(true)
    }
  }

  return (
    <div>
      <Dialog
        visible={showDialog}
        onHide={() => cerrarDialog()}
        header={"Comprobante de Caja Chica"}
        style={{ width: "90vw", height: "90vh" }}
        maximizable
        maximized
      >
        <Loader loading={loading} />
        <Toast ref={toast} />

        {/* ENCABEZADO */}
        <div className="d-flex flex-column">
          <Card
            contenido={
              <div className="d-flex">
                <div className="col-12">
                  {/* ------------------------- CAMPOS ----------------------- */}
                  <div className="d-flex flex-wrap align-items-start gap-2 mt-2">
                    {/* No. Nota */}
                    <span className=" field p-float-label">
                      <InputText
                        id="NumeroComprobante"
                        name="NumeroComprobante"
                        value={values?.NumeroComprobante}
                        onChange={handleInputChange}
                        style={{ fontWeight: "bold" }}
                        disabled={!habilitar}
                      />
                      <label htmlFor="NumeroComprobante">No. Comprobante</label>
                    </span>
                    
                    <span className=" field p-float-label">
                      <InputText
                        disabled
                        id="StatusName"
                        name="StatusName"
                        style={{ width: "235px" }}
                        value={values?.StatusName}
                        onChange={handleInputChange}
                      />
                      <label htmlFor="StatusName">Estado</label>
                    </span>

                    {/* Fecha Comprobante*/}
                    <span className="p-float-label">
                      <Calendar
                        id="FechaComprobanteStr"
                        name="FechaComprobanteStr"
                        disabled={!habilitar}
                        onChange={(e) => handleInputChange(e, "FechaComprobanteStr")}
                        value={values?.FechaComprobanteStr}
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        showIcon
                        style={{height: 45}}
                      />
                      <label htmlFor="FechaComprobanteStr">Fecha Comprobante</label>
                    </span>

                    
                    <AutoCompleteDropdown
                      enable={habilitar}
                      value={values?.TipoPersonal}
                      items={tiposPersonal}
                      field={"TipoPersonal"}
                      name={"TipoPersonal"}
                      handleInputChange={handleInputChange}
                      label={"Tipo Personal"}
                    />

                    <AutoCompleteDropdown
                      enable={habilitar}
                      value={values?.NombreCompletoPrimer}
                      items={personal}
                      field={"NombreCompletoPrimer"}
                      name={"NombreCompletoPrimer"}
                      handleInputChange={handleInputChange}
                      label={"Personal"}
                    />

                    <span className=" field p-float-label">
                      <InputText
                        disabled
                        id="Moneda"
                        name="Moneda"
                        style={{ width: "235px" }}
                        value={IdCurrency === 2 ? 'Lempira' : 'Dolar'}
                        onChange={handleInputChange}
                      />
                      <label htmlFor="Moneda">Moneda</label>
                    </span>

                    <span className=" field p-float-label">
                      <InputNumber
                        disabled={!habilitar}
                        minFractionDigits={4}
                        maxFractionDigits={4}
                        useGrouping={true}
                        id="TasaCambio"
                        name="TasaCambio"
                        style={{ width: "235px" }}
                        value={values?.TasaCambio}
                        onChange={handleInputChange}
                      />
                      <label htmlFor="TasaCambio">Tasa Cambio</label>
                    </span>

                    <span className=" field p-float-label">
                      <InputNumber
                        disabled={!habilitar}
                        minFractionDigits={4}
                        maxFractionDigits={4}
                        useGrouping={true}
                        id="CantidadEntregada"
                        name="CantidadEntregada"
                        style={{ width: "235px" }}
                        value={values?.CantidadEntregada}
                        onChange={handleInputChange}
                      />
                      <label htmlFor="CantidadEntregada">Cantidad Entregada</label>
                    </span>

                    <AutoCompleteDropdown
                      enable={habilitar}
                      value={values?.Area}
                      items={areas}
                      field={"Area"}
                      name={"Area"}
                      handleInputChange={handleInputChange}
                      label={"Area"}
                    />

                    <AutoCompleteDropdown
                      enable={habilitar}
                      value={values?.Area}
                      items={areas}
                      field={"Area"}
                      name={"Area"}
                      handleInputChange={handleInputChange}
                      label={"Autoriza"}
                    />

                    {/* Concepto */}
                    <span className=" p-float-label d-flex">
                      <InputTextarea
                        disabled={!habilitar}
                        id="Concepto"
                        name="Concepto"
                        value={values?.Concepto}
                        onChange={handleInputChange}
                        cols={88}
                        style={{ height: "3rem" }}
                      />
                      <label htmlFor="Concepto">Concepto</label>
                    </span>

                    <span className=" field p-float-label">
                        <InputNumber
                            disabled={!habilitar}
                            minFractionDigits={4}
                            maxFractionDigits={4}
                            useGrouping={true}
                            id="CantidadFactura"
                            name="CantidadFactura"
                            style={{ width: "250px" }}
                            value={values?.CantidadFactura}
                            onChange={handleInputChange}
                        />
                        <label htmlFor="CantidadFactura">Cantidad Factura</label>
                    </span>

                    <span className=" field p-float-label">
                        <InputNumber
                            disabled={!habilitar}
                            minFractionDigits={4}
                            maxFractionDigits={4}
                            useGrouping={true}
                            id="Diferencia"
                            name="Diferencia"
                            style={{ width: "250px" }}
                            value={values?.Diferencia}
                            onChange={handleInputChange}
                        />
                        <label htmlFor="Diferencia">Diferencia</label>
                    </span>

                    <span className=" p-float-label d-flex">
                      <InputTextarea
                        disabled={!habilitar}
                        id="CantidadLetras"
                        name="CantidadLetras"
                        value={values?.CantidadLetras}
                        onChange={handleInputChange}
                        cols={89}
                        style={{ height: "3rem" }}
                      />
                      <label htmlFor="CantidadLetras">Cantidad Letras</label>
                    </span>

                  </div>

                  {/* --------------------------BOTONES-----------------------  */}
                  <div className="d-flex flex-wrap gap-1 mb-2 mt-3">
                    <Button
                      icon="pi pi-plus"
                      type="button"
                      onClick={() => agregarNuevaFila()}
                      tooltip="Agregar Detalle"
                      tooltipOptions={{ position: "top" }}
                      disabled={!habilitar}
                    />

                    <Button
                      icon="pi pi-pencil"
                      type="button"
                      onClick={() => setHabilitar(true)}
                      tooltip="Editar"
                      tooltipOptions={{ position: "top" }}
                      disabled={
                        values?.IdComprobante <= 0 ||
                        values?.IdStatus === 95 ||
                        values?.IdStatus === 96 ||
                        values?.IdStatus === 97
                      }
                    />

                    <Button
                      icon="pi pi-save"
                      type="button"
                      onClick={guardarNota}
                      tooltip="Guardar"
                      tooltipOptions={{ position: "top" }}
                      disabled={!habilitar || detalles?.length === 0}
                    />

                    <Button
                      icon="pi pi-times"
                      type="button"
                      className="p-button-danger"
                      onClick={() => EliminarDetalle()}
                      tooltip="Eliminar"
                      disabled={!habilitar || selected?.length === 0}
                      tooltipOptions={{ position: "top" }}
                    />
                    <Button
                      icon="pi pi-sync"
                      type="button"
                      onClick={() => getValoresIniciales()}
                      tooltip="Cargar"
                      tooltipOptions={{ position: "top" }}
                    />

                    <Button
                      icon="pi pi-book"
                      type="button"
                      onClick={() => {
                        confirmDialog({
                          message: "¿Está seguro que desea crear nueva nota?",
                          header: "Crear Nueva Nota",
                          icon: "pi pi-exclamation-triangle",
                          accept: () => {
                            getNuevaNota()
                          },
                        })
                      }}
                      tooltip="Nueva Nota"
                      tooltipOptions={{ position: "top" }}
                    />


                    <Button
                      icon="ri-check-double-line"
                      onClick={() => AplicarNotaCredito()}
                      disabled={values?.IdComprobante <= 0 || values?.IdStatus === 97}
                      tooltip="Aplicar Nota"
                      tooltipOptions={{ position: "top" }}
                    />

                    {/* {userAuth?.IdRol === 1 && (
                      <Button
                        icon="ri-check-double-line"
                        label="Aplicar Nota"
                        type="button"
                        onClick={() => getValoresIniciales()}
                        tooltip="Aplicar Nota"
                        tooltipOptions={{ position: "top" }}
                        disabled={values?.IdStatus !== 95}
                      />
                    )} */}
                  </div>
                </div>
              </div>
            }
          />
        </div>

        {/* DETALLES */}
        <Card
          contenido={
            <div style={{ height: "56vh" }}>
              <AgGrid table={table} />
            </div>
          }
        />
      </Dialog>

    </div>
  );
};

export default ComprobanteCRUD;

